var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipe14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 205,
    viewBox: "0 0 167 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 159.5L45.5 1.1731e-05L0.499999 1.52588e-05L0.499997 162C0.499997 185.472 19.5279 204.5 43 204.5L167 204.5L167 159.5L45.5 159.5Z",
    fill: "#BED4ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 79.189L3.01195 62.3917L41.9511 62.3917L22.4815 79.189Z",
    fill: "url(#paint0_linear_1_18)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 65.7925L3.0305 48.9952L41.9696 48.9952L22.5001 65.7925Z",
    fill: "url(#paint1_linear_1_18)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5186 52.3964L3.04906 35.5991L41.9882 35.5991L22.5186 52.3964Z",
    fill: "url(#paint2_linear_1_18)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.188 182.519L108.391 201.989L108.391 163.05L125.188 182.519Z",
    fill: "url(#paint3_linear_1_18)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.792 182.501L94.9947 201.97L94.9947 163.031L111.792 182.501Z",
    fill: "url(#paint4_linear_1_18)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3964 182.482L81.5991 201.951L81.5991 163.012L98.3964 182.482Z",
    fill: "url(#paint5_linear_1_18)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_18",
    x1: 22.4815,
    y1: 79.189,
    x2: 22.4815,
    y2: 56.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_18",
    x1: 22.5001,
    y1: 65.7925,
    x2: 22.5001,
    y2: 43.3961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_18",
    x1: 22.5186,
    y1: 52.3964,
    x2: 22.5186,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_18",
    x1: 125.188,
    y1: 182.519,
    x2: 102.792,
    y2: 182.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_18",
    x1: 111.792,
    y1: 182.501,
    x2: 89.3956,
    y2: 182.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_18",
    x1: 98.3964,
    y1: 182.482,
    x2: 76,
    y2: 182.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe14);
export default __webpack_public_path__ + "static/media/pipe-14.4ac3d484e143316c08399f2d3a5cd48c.svg";
export { ForwardRef as ReactComponent };